import { BaseDto } from "src/dtos/common/baseDto";

export interface UserAutDto extends BaseDto {
	userId: string;
	menuCd: string;
	queryAut: string;
	insertAut: string;
	deleteAut: string;
	saveAut: string;
	printAut: string;
	excelAut: string;
	remark: string;
	inserted: boolean;
	isModified: boolean;
}

export const defaultUserAutDto: UserAutDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	userId: '',
	menuCd: '',
	queryAut: '',
	insertAut: '',
	deleteAut: '',
	saveAut: '',
	printAut: '',
	excelAut: '',
	remark: '',
	inserted: false,
	isModified: false,
};
